import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Toastmodal from "../Toastmodal";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';

function Subcatadd() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);

  const [level1name, setLevel1name] = useState("");
  const [description, setDescription] = useState("");
  const [image, setimage] = useState("");
  const [level, setLevel] = useState("");
  const [level1cat, setLevel1cat] = useState("");
  const [level2cat, setLevel2cat] = useState("");
  const [level3cat, setLevel3cat] = useState("");

  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});
  const [formerror2, setError2] = useState({});
  const [formerror3, setError3] = useState({});
  const [formerror4, setError4] = useState({});
  const [formerror5, setError5] = useState({});
  const [formerror6, setError6] = useState({});

  const [level1categories, setLevel1categories] = useState([]);
  const [level2categories, setLevel2categories] = useState([]);
  const [level3categories, setLevel3categories] = useState([]);

  let name, value;
  // const handleInputs = (e) => {
  //   console.log(e);
  //   name = e.target.name;
  //   value = e.target.value;
  //   setService({ ...service, [name]: value });
  // };
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=1`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setLevel1categories(data.data);

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  const getinfo1 = async (e) => {
    if (level1cat) {
      const res1 = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=2`,
        {
          method: "POST",
          body: JSON.stringify({
            levelOneCategory: level1cat,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      if (res1.status === 200 ) {
        const data = await res1.json();
        setLevel2categories(data.data[0].subCategories);

      }
      else if(res1.status === 401){
        handleUnauthorized();
        getinfo1();
      }
      else {
        alert("error");

      }
    }
  };
  const getinfo2 = async (e) => {
    if (level1cat && level2cat) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=3`,
        {
          method: "POST",
          body: JSON.stringify({
            levelOneCategory: level1cat,
            levelTwoCategory: level2cat,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      if (res.status === 200 ) {
        const data = await res.json();
        setLevel3categories(data.data[0].subCategories);

      }
      else if(res.status === 401){
        handleUnauthorized();
        getinfo2();
      }
      else {
        alert("error");

      }
    }
  };

  // getinfo1();
  // getinfo2();
  const onFileChange = (e) => {
    setimage(e.target.files[0]);
  };

  const validate = (values) => {
    const errors = {};
    if (!values) {
      errors.level1name = "Name is required!";
    }

    return errors;
  };

  const validate1 = (values) => {
    const errors = {};
    if (!values) {
      errors.description = "Description is required!";
    }

    return errors;
  };
  const validate2 = (values) => {
    const errors = {};
    if(level==="1"){
      if (!values) {
        errors.image = "Image is required!";
      } else {
        if (
          values.type === "image/jpeg" ||
          values.type === "image/jpg" ||
          values.type === "image/png"
        ) {
          if (values.size > 1024 * 1000) {
            errors.image =
              "maximum file size 1 mb...please upload an image less than 1 mb";
          }
        } else {
          errors.image = "Only support jpg, jpeg, png image!";
        }
      }
    }
    else{
      if (values) {
        if (
          values.type === "image/jpeg" ||
          values.type === "image/jpg" ||
          values.type === "image/png"
        ) {
          if (values.size > 1024 * 1000) {
            errors.image =
              "maximum file size 1 mb...please upload an image less than 1 mb";
          }
        } else {
          errors.image = "Only support jpg, jpeg, png image!";
        }
      }
    }

    return errors;
  };
  const validate3 = (values) => {
    const errors = {};
    if (!values) {
      errors.level = "Level is required!";
    }

    return errors;
  };
  const validate4 = (values) => {
    const errors = {};
    if (!values) {
      errors.level1cat = "Level 1 category is required!";
    }

    return errors;
  };
  const validate5 = (values) => {
    const errors = {};
    if (!values) {
      errors.level2cat = "Level 2 category is required!";
    }

    return errors;
  };
  const validate6 = (values) => {
    const errors = {};
    if (!values) {
      errors.level3cat = "Level 3 category is  required!";
    }

    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const ress = validate(level1name);
    const ressdes = validate1(description);
    const ressimage = validate2(image);
    const resslevel = validate3(level);
    let resslevel1cat = "";
    let resslevel2cat = "";
    let resslevel3cat = "";
    setError(ress);
    setError1(ressdes);

    setError2(ressimage);
    setError3(resslevel);
    if (level === "4") {
      resslevel1cat = validate4(level1cat);
      resslevel2cat = validate5(level2cat);
      resslevel3cat = validate6(level3cat);

      setError4(resslevel1cat);

      setError5(resslevel2cat);
      setError6(resslevel3cat);
    } else if (level === "3") {
      resslevel1cat = validate4(level1cat);
      resslevel2cat = validate5(level2cat);
      setError4(resslevel1cat);

      setError5(resslevel2cat);
    } else if (level === "2") {
      resslevel1cat = validate4(level1cat);

      setError4(resslevel1cat);
    } else if (level === "1") {
    }
    if (
      !ress.level1name &&
      !ressdes.description &&
      !ressimage.image &&
      !resslevel.level &&
      !resslevel1cat.level1cat &&
      !resslevel2cat.level2cat &&
      !resslevel3cat.level3cat
    ) {
      const formData = new FormData();
      formData.append("categoryName", level1name);
      formData.append("categoryDescription", description);
      if(image){
      formData.append("categoryImg", image);
      }
      formData.append("categoryLevel", level);
      formData.append("levelOneCategory", level1cat);
      formData.append("levelTwoCategory", level2cat);
      formData.append("levelThreeCategory", level3cat);

      axios
        .post(`${Config.apiurl}/api/v1/crm/service-category/create`, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200 ) {
            setToastmodal(true);
            setToastmessage("Sucessfully Created Category");
            setToasttype("success");
            setToastlarge(false);

            setTimeout(() => navigate("/dashboard"), 3000);

           
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage(res.message);
            setToasttype("error");
            setToastlarge(true);
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
    getinfo1();
    getinfo2();
  }, [level1cat, level2cat, level3cat]);
  function leve1(val) {
    setLevel1cat(val);
    getinfo1();
  }

  function leve2(val) {
    setLevel2cat(val);
    getinfo2();
  }
  function levelset(val) {
    setLevel(val);
    getinfo();
    getinfo1();
    getinfo2();
  }

  const updateValue = ({ target }) => {
    setLevel1cat(target.value);
    getinfo1();
  };
  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Servicecategory Table</h4>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Category Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Category name"
                            name="Category Name"
                            value={level1name}
                            onChange={(e) => setLevel1name(e.target.value)}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.level1name}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Description"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          />
                          <label style={{ color: "red" }}>
                            {formerror1.description}
                          </label>
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Level</label>
                          <select
                            className="form-control "
                            style={{
                              color: "black",
                              backgroundColor: "#2b2e4c;",
                            }}
                            id="exampleInputUsername1"
                            name="level"
                            onChange={(e) => levelset(e.target.value)}
                            value={level}
                          >
                            <option id="exampleInputUsername1">
                              Choose Level
                            </option>

                            <option
                              id="exampleInputUsername1"
                              name="level"
                              value={1}
                            >
                              1
                            </option>
                            <option
                              id="exampleInputUsername1"
                              name="level"
                              value={2}
                            >
                              2
                            </option>
                            <option
                              id="exampleInputUsername1"
                              name="level"
                              value={3}
                            >
                              3
                            </option>
                            <option
                              id="exampleInputUsername1"
                              name="level"
                              value={4}
                            >
                              4
                            </option>
                          </select>

                          <label style={{ color: "red" }}>
                            {formerror3.level}
                          </label>
                        </div>
                        {level === "4" ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level1 Category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level"
                                onChange={(e) => {
                                  setLevel1cat(e.target.value);
                                  getinfo1();
                                }}
                                value={level1cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level1categories.map((cate, index) => {
                                  return (
                                    <option key={index} value={cate._id}>
                                      {cate.categoryName}
                                    </option>
                                  );
                                })}
                              </select>

                              <label style={{ color: "red" }}>
                                {formerror4.level1cat}
                              </label>
                            </div>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level2 category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level2cat"
                                onChange={(e) => {
                                  setLevel2cat(e.target.value);
                                  getinfo2();
                                }}
                                value={level2cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level2categories.map((cate1, index) => {
                                  return (
                                    <option key={index} value={cate1._id}>
                                      {cate1.categoryName}
                                    </option>
                                  );
                                })}
                              </select>

                              <label style={{ color: "red" }}>
                                {formerror5.level2cat}
                              </label>
                            </div>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level3 Category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level3cat"
                                onChange={(e) => setLevel3cat(e.target.value)}
                                value={level3cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level3categories.map((cate2, index) => {
                                  return (
                                    <option key={index} value={cate2._id}>
                                      {cate2.categoryName}
                                    </option>
                                  );
                                })}
                              </select>
                              {/* <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Description"
                          name="level"
                          value={level}
                          onChange={(e) => setLevel(e.target.value)}
                        /> */}
                              <label style={{ color: "red" }}>
                                {formerror6.level3cat}
                              </label>
                            </div>
                          </>
                        ) : level === "3" ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level1 Category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level"
                                // onChange={(e) => leve1(e.target.value)}
                                onChange={(e) => {
                                  setLevel1cat(e.target.value);
                                  getinfo1();
                                }}
                                value={level1cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level1categories.map((cate, index) => {
                                  return (
                                    <option key={index} value={cate._id}>
                                      {cate.categoryName}
                                    </option>
                                  );
                                })}
                              </select>

                              <label style={{ color: "red" }}>
                                {formerror4.level1cat}
                              </label>
                            </div>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level2 category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level2cat"
                                onChange={(e) => {
                                  setLevel2cat(e.target.value);
                                  getinfo2();
                                }}
                                value={level2cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level2categories.map((cate1, index) => {
                                  return (
                                    <option key={index} value={cate1._id}>
                                      {cate1.categoryName}
                                    </option>
                                  );
                                })}
                              </select>

                              <label style={{ color: "red" }}>
                                {formerror5.level2cat}
                              </label>
                            </div>
                          </>
                        ) : level === "2" ? (
                          <>
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Level1 Category
                              </label>
                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="level"
                                onChange={(e) => leve1(e.target.value)}
                                value={level1cat}
                              >
                                <option id="exampleInputUsername1">
                                  Choose Level
                                </option>

                                {level1categories.map((cate, index) => {
                                  return (
                                    <option key={index} value={cate._id}>
                                      {cate.categoryName}
                                    </option>
                                  );
                                })}
                              </select>

                              <label style={{ color: "red" }}>
                                {formerror4.level1cat}
                              </label>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Image (407px * 273px)
                          </label>
                          <br></br>
                          <input
                            type="file"
                            name="image"
                            onChange={onFileChange}
                          />
                          <label style={{ color: "red" }}>
                            {formerror2.image}
                          </label>
                        </div>
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default Subcatadd;
